import Game from "./scenes/Game";
import SelectScreen from "./scenes/SelectScreen";

export default {
  /**
   * Add your scene classes here. Simply put the scene class.
   * Ex: `scenes: [MyScene,MyOtherScene]`
   * @type {{KEY:string}[]}
   */
  scenes: [SelectScreen, Game],

  /**
   * Set the first scene that should be loaded here. Must match one of the scenes' key found in the scenes array.
   * It is recommended you put `MyScene.KEY` here instead of using a string.
   * @type {string}
   */
  startScene: SelectScreen.KEY,
  //startScene: Game.KEY,

  puzzleAttempts: [],
  levelInfo: {
    totalLevels: 10,
    maxLevel: 10,
    currentLevel: 1,
    selectedLevels: [],
    completedLevels: [],
    perfectLevels: [],
    currentLevelIndex: 0
  },

  isAlphabet: true,
  isUppercase: true
}
